module.exports = __webpack_public_path__ + "img/b846c0ee7485a368e84eb33a84a7af25.png";